module.exports = __webpack_public_path__ + "media/images/profiles/profile-4-a4d1879ba6ca2ce29c4d3c2a4292e4e5.png";